import moment from 'moment-timezone';
import { useSelector } from 'react-redux';

import { DATE_TIME_FORMAT, DAY_COMMA_DATE_FORMAT } from 'src/shared/constants';
import { formatTime } from 'src/shared/utils';
import { getTimeFormat } from 'src/store/user/user.selectors';

type ReturnType = { endDate: string; startTime: string | undefined; endTime: string | undefined; startDate: string };

interface Props {
  rawStartDate: string;
  rawEndDate: string;
  rawStartTime?: string | null;
  rawEndTime?: string | null;
}

/**
 * Returns the formatted startDate, endDate, startTime and endTime values
 */
export const useAbsenceDates = ({ rawStartDate, rawEndDate, rawStartTime, rawEndTime }: Props): ReturnType => {
  const timeFormat = useSelector(getTimeFormat);

  const startDate = moment(rawStartDate).format(DAY_COMMA_DATE_FORMAT);
  const endDate = moment(rawEndDate).format(DAY_COMMA_DATE_FORMAT);
  const startTime = rawStartTime ? formatTime(rawStartTime, timeFormat, DATE_TIME_FORMAT) : undefined;
  const endTime = rawEndTime ? formatTime(rawEndTime, timeFormat, DATE_TIME_FORMAT) : undefined;

  return { startDate, endDate, startTime, endTime };
};
